
export class GlobalConstants {

  public static appInfo = {
    appTitle: 'Labcorp | Payer™',
    appYear: new Date().getFullYear()
  };

  public static mainNav = [
    {
      title: 'FTP Searches',
      iconName: 'backup',
      route: '/portal/ftp',
    },
    {
      title: 'Organizations',
      iconName: 'business',
      route: '/portal/organizations',
    },
    {
      title: 'Users',
      iconName: 'people',
      route: '/portal/users',
    },

  ];
}